import { BaseService, NOME_TOKEN_ACESSO_DIRETO } from '@thema/base-servicos'

const urlAnexo = '/service/portal/grupoAnexo/'

class AnexoService extends BaseService {
    constructor() {
        const config = JSON.parse(sessionStorage.getItem('config'))
        super(NOME_TOKEN_ACESSO_DIRETO, config)
    }

    getAnexosPorConteudo(conteudo) {
        return this.conex.get(urlAnexo + conteudo)
    }
}

export default AnexoService
